import { IconButton } from "@fluentui/react";
import { useTheme } from "cayo.ui";
import {
  defaultAlertWidth,
  getMenuButtonStyles,
} from "@cayo/shared/components/Alerts/Alerts.styles";
import { useToggleNavCollapsed } from "../Nav/nav-hooks";

const ToggleNavCollapseButton = () => {
  const { toggleCollapsed } = useToggleNavCollapsed();
  const theme = useTheme();
  return (
    <IconButton
      aria-label="Menu button"
      iconProps={{ iconName: "GlobalNavButton" }}
      onClick={toggleCollapsed}
      styles={getMenuButtonStyles(false, theme, defaultAlertWidth, undefined)}
    />
  );
};

export default ToggleNavCollapseButton;
